module.exports = __webpack_public_path__ + "img/Article4B.6853e958.jpg";